import React from 'react';
import ReactApexChart from 'react-apexcharts';

const SocialMediaInsights = () => {
    const [state, setState] = React.useState({
        series: [28, 54, 2, 16],

        options: {
            chart: {
                height: 390,
                type: 'radialBar',
            },

            plotOptions: {
                radialBar: {
                    startAngle: 0,
                    endAngle: 270,
                    offsetY: 0,
                    hollow: {
                        margin: 5,
                        size: '30%',
                        background: 'transparent',
                    },
                    dataLabels: {
                        name: { show: false },
                        value: { show: false },
                    },
                    barLabels: {
                        enabled: true,
                        useSeriesColors: true,
                        offsetX: -8,
                        fontSize: '16px',
                        formatter: (seriesName, opts) => opts.w.globals.series[opts.seriesIndex],
                    },
                },
            },

            labels: ['Facebook', 'Instagram', 'LinkedIn', 'Twitter'],

            // ✅ Gradient fill setup
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    type: 'horizontal', // Try vertical or diagonal for different effects
                    gradientToColors: ['#6d4dbf', '#ac4290', '#cc6ea0', '#9bbce2'],
                    stops: [0, 100],
                },
            },

            colors: ['#9bbce2', '#ac4290', '#cc6ea0', '#6d4dbf'], // Start colors

            legend: {
                show: true,
                position: 'bottom',
                formatter: (seriesName) => seriesName,
            },

            tooltip: {
                enabled: true,
                y: {
                    formatter: (val) => `${val}%`,
                },
            },

            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            show: false,
                        },
                    },
                },
            ],
        },
    });

    return (
        <div>
            <div id="chart">
                <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="radialBar"
                    height={390}
                />
            </div>
        </div>
    );
};

export default SocialMediaInsights;
